import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingOverlayService } from '../services/loading-overlay.service';

/**
 * Interceptor que muestra el overlay de carga (logo con pulse) en cada petición HTTP
 * y lo oculta al recibir respuesta o error.
 */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingOverlay: LoadingOverlayService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.loadingOverlay.show();
    return next.handle(req).pipe(
      finalize(() => this.loadingOverlay.hide())
    );
  }
}
